import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import api from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

export default function Blog() {
  const { data: blogs = [], isLoading } = useQuery({ queryKey: ["blogs"], queryFn: () => api.get("/blogs").then((r) => r.data) });

  return (
    <div className="pt-32">
      <div className="container-px mx-auto max-w-[1600px] pb-24">
        <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-cyan">The Journal</p>
        <h1 className="font-display text-5xl font-extrabold uppercase leading-none text-foreground md:text-8xl">Insights</h1>
        <p className="mt-6 max-w-xl text-muted-foreground">Field notes, guides and honest breakdowns for the first-time Indian home buyer.</p>

        {isLoading ? (
          <p className="mt-16 font-mono text-sm text-muted-foreground">Loading…</p>
        ) : (
          <div className="mt-16 grid gap-px border border-border bg-border md:grid-cols-2 lg:grid-cols-3">
            {blogs.map((b, i) => (
              <Reveal key={b.id} delay={(i % 3) * 0.08}>
                <Link to={`/blog/${b.slug}`} className="group flex h-full flex-col bg-background transition-colors hover:bg-card" data-testid={`blog-card-${b.id}`}>
                  <div className="relative aspect-[16/10] overflow-hidden">
                    {b.cover_image && <img src={b.cover_image} alt={b.title} className="h-full w-full object-cover transition-all duration-700 group-hover:scale-105" />}
                    <span className="absolute left-4 top-4 border border-white/20 bg-black/60 px-2 py-1 font-mono text-[10px] uppercase tracking-widest text-white backdrop-blur">{b.category}</span>
                  </div>
                  <div className="flex flex-1 flex-col p-6">
                    <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{b.read_time} read</span>
                    <h3 className="mt-3 font-display text-2xl font-bold uppercase leading-tight text-foreground group-hover:text-cyan">{b.title}</h3>
                    <p className="mt-3 flex-1 text-sm text-muted-foreground">{b.excerpt}</p>
                    <span className="mt-5 flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-foreground group-hover:text-cyan">
                      Read <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
